import { Injectable } from '@angular/core';
import { formatBytes } from '../../core';

@Injectable({
	providedIn: 'root'
})
export class StorageStateService {
	isPersistentStorage = false;
	storageEstimate?: StorageEstimate;

	private readonly STORAGE_WARNING_THRESHOLD = 0.8;

	constructor() {
		this.updateStorageInfo();
	}

	updateStorageInfo() {
		if (navigator.storage) {
			if (navigator.storage.persist) {
				navigator.storage.persist().then((isPersisted) => {
					this.isPersistentStorage = isPersisted;
				});
			}
			if (navigator.storage.estimate) {
				navigator.storage.estimate().then((estimate) => {
					this.storageEstimate = estimate;
				});
			}
		}
	}

	get storageUsagePercent(): number {
		const estimate = this.storageEstimate;
		const used = estimate?.usage ?? 0;
		const quota = estimate?.quota ?? 0;
		return quota > 0 ? Math.round((used / quota) * 100) : 0;
	}

	get isStorageLow(): boolean {
		const estimate = this.storageEstimate;
		const used = estimate?.usage ?? 0;
		const quota = estimate?.quota ?? 0;
		return quota > 0 && (used / quota) >= this.STORAGE_WARNING_THRESHOLD;
	}

	storageMessage() {
		if (!navigator.storage || !navigator.storage.estimate) {
			return 'Storage API not supported';
		}
		const estimate = this.storageEstimate;
		const used = estimate?.usage ?? 0;
		const quota = estimate?.quota ?? 0;
		const percent = this.storageUsagePercent;
		const persistent = this.isPersistentStorage ? ' (persistent)' : ' (temporär)';

		let warning = '';
		if (this.isStorageLow) {
			warning = ' ⚠️ Speicher knapp!';
		}

		return `${formatBytes(used)}/${formatBytes(quota)} (${percent}%)${persistent}${warning}`;
	}
}
